import { Link } from 'react-router-dom';

import { Links } from 'links';

import { OfferWithFrequencyCap } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<OfferWithFrequencyCap>[] = [{
  width: 80,
  title: 'ID',
  dataIndex: 'offer.id',
  render: (_, { offer: { order, id } }) => (
    <Link
      to={`${Links.Offers}/${id}`}
      state={{ redirectFrom: `${Links.Offers}${window.location.search}` }}
    >
      {order}
    </Link>
  ),
}, {
  width: 350,
  title: 'Offer name',
  dataIndex: 'offer.name',
}, {
  type: TColumn.type.FetchImageByID,
  title: 'Offer image',
  dataIndex: 'offer.imageMetadataId',
}, {
  title: 'Redeemed count',
  dataIndex: 'redeemedCount',
  align: 'center',
}, {
  title: 'Max redeem count',
  dataIndex: 'maxRedeemCount',
  align: 'center',
}];
